// extracted by mini-css-extract-plugin
export var boldText = "_7e-4";
export var checkboxContainer = "_7e-6";
export var closeIcon = "_7e-i";
export var container = "_7e-0";
export var drawer = "_7e-8";
export var drawerContent = "_7e-9";
export var extraSmallText = "_7e-5";
export var fulfillmentGroupTable = "_7e-e";
export var largeText = "_7e-3";
export var loadingSpinnerContainer = "_7e-j";
export var mediumText = "_7e-2";
export var narrow = "_7e-f";
export var notificationLink = "_7e-l";
export var packageCheckIconContainer = "_7e-7";
export var slideoutHeaderActions = "_7e-g";
export var slideoutHeaderActionsShifted = "_7e-h";
export var slideoutHeaderContainer = "_7e-a";
export var slideoutModal = "_7e-c";
export var stickyHeaderWrapper = "_7e-b";
export var table = "_7e-k";
export var tableContainer = "_7e-d";
export var tertiaryText = "_7e-1";